module.exports = __webpack_public_path__ + "static/media/wmsui32_3912.b6201154.ico";